export const style = { height: 36, padding: 0 };
